import React, { Component } from "react";
import {
  PageHeader,
  Tag,
  Button,
  Statistic,
  Row,
  Col,
  Dropdown,
  Menu,
  Table,
  Input,
  Space,
  Spin,
  DatePicker,
  Form,
  Select
} from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET, DELETE, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import {
  order,
  delete_order,
  update_order,
  get_all_order,
  user,
  get_all_user
} from "../constants/routes";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { decryptSingleData, encryptData } from "../functions/cryptojs";
import { google_map_key } from "../constants/mapkey";
import GoogleMapReact from "google-map-react";
import { CSVLink, CSVDownload } from "react-csv";

import startIcon from "../../assets/start.png";
import dest from "../../assets/dest.png";
import bike from "../../assets/bike.png";
import { todayDate } from "../functions/dateFunctions";

const token = sessionStorage.getItem("auth_token");

const { RangePicker } = DatePicker;

const { Option } = Select;

class Order extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    list: [],
    chef: [],
    chef_selected: null,
    selected_date: todayDate(),
    start: null,
    end: null,
    selected: true,
    overall: true,
    allowed: false,
    blocked: false,
    driver_around: [],
    openModal: false,
    ride_selected: null,
    show: "all",
    rate: null,
    rate_view: false
  };

  componentDidMount() {
    this.getData();
  }

  static defaultProps = {
    center: {
      lat: 43.65107,
      lng: -79.347015
    },
    zoom: 5
  };

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: "order-glocery/get-glocery-orders/" + this.props.admin._id,
      data: null,
      token: token
    };

    const response = await MakeRequestAsync(request_details).catch((err) => {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    });

    this.setState({
      load: false,
      data: decryptSingleData(response.data.order)
    });
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: "order-glocery" + "/" + "update-order" + "/" + id,
      data: data,
      token: token
    };

    const response = await MakeRequestAsync(request_details).catch((err) => {
      return openNotificationWithIcon("error", `${err.response.data}`);
    });
    return setTimeout(() => window.location.reload(), 1000);
  };

  onSelectChange = (selectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleDelete = async (id) => {
    const request_details = {
      type: DELETE,
      url: service_api,
      route: "order-glocery" + "/" + delete_order + "/" + id,
      token: token
    };
    const response = await MakeRequestAsync(request_details).catch((err) => {
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    });

    return setTimeout(() => window.location.reload(), 1000);
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",
        // width: "20%",
        ...this.getColumnSearchProps("_id")
        // fixed: "left"
      },
      // {
      //   title: "Action",
      //   dataIndex: "data",
      //   width: "5%",
      //   render: (text, record) => (
      //     <Button
      //       type="primary"
      //       onClick={() => {
      //         this.setState({ ride_selected: record });
      //       }}
      //     >
      //       Selection Map
      //     </Button>
      //   )
      // },
      {
        title: "Billing details",
        dataIndex: "billing_details",
        render: (text) => (
          <Tag color={"purple"}>
            {/* <span>
              Montant total: <b>{"$" + text?.amount?.toFixed(2)}</b>
            </span> */}
            <span>
              Gain (My shop): <b>{"$" + text?.earned_glocery?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain pani: <b>{"$" + text?.earned_pani?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Date de commande: <b>{text?.delivery_date}</b>
            </span>
          </Tag>
        )
      },
      {
        title: "Paid",
        dataIndex: "paid",
        render: (text) => (
          <Tag color={text === true ? "green" : "volcano"}>
            {text === true ? "Yes" : "No"}
          </Tag>
        )
      },
      {
        title: "Articles",
        dataIndex: "food",
        render: (text) =>
          text?.map((item) => (
            <>
              <Tag
                color={"purple"}
                style={{
                  marginTop: 5
                }}
              >
                <a href={item?.pic} target="_blank">
                  <img
                    src={item?.pic}
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: "contain"
                    }}
                    alt={"food-logo"}
                  />
                </a>
                <br />
                <span>
                  <b>{item?.name}</b>
                </span>
                <br />
                <span>
                  Qty:<b>{item?.qty}</b>
                </span>
                <br />
                <span>
                  Cost: <b>${item?.cost * item?.qty}</b>
                </span>
              </Tag>
              <br />
            </>
          ))
      },
      {
        title: "Chef",
        dataIndex: "chef_id",
        render: (text) => (
          <Tag color={"purple"}>
            <span>{text?.firstname + " " + text?.lastname}</span>
            <br />
            <span>{text?.email}</span>
            <br />
            <span>{text?.number}</span>
          </Tag>
        )
      },
      // {
      //   title: "Chef",
      //   dataIndex: "chef_id",
      //   render: (text) => (
      //     <Tag color={"purple"}>
      //       <span>{text?.firstname + " " + text?.lastname}</span>
      //       <br />
      //       <span>{text?.email}</span>
      //       <br />
      //       <span>{text?.number}</span>
      //     </Tag>
      //   )
      // },
      // {
      //   title: "Livreur",
      //   dataIndex: "deliverman_id",
      //   render: (text) =>
      //     text === null ? (
      //       "Aucun Livreur"
      //     ) : (
      //       <Tag color={"purple"}>
      //         <img
      //           src={text?.pic}
      //           style={{
      //             width: 60,
      //             height: 60,
      //             objectFit: "contain"
      //           }}
      //           alt={"deliverman-logo"}
      //         />
      //         <br />
      //         <span>{text?.firstname + " " + text?.lastname}</span>
      //         <br />
      //         <span>{text?.email}</span>
      //         <br />
      //         <span>{text?.number}</span>
      //       </Tag>
      //     )
      // },
      // {
      //   title: "Note Plat",
      //   dataIndex: "rate_food",
      //   render: (text) =>
      //     text?.rate === null ? (
      //       "Aucun"
      //     ) : (
      //       <Tag color={"purple"}>
      //         <span>{text?.text}</span>
      //         <br />
      //         <span>{text?.rate} etoiles</span>
      //       </Tag>
      //     )
      // },
      // {
      //   title: "Note Livreur",
      //   dataIndex: "rate_driver",
      //   render: (text) =>
      //     text?.rate === null ? (
      //       "Aucun"
      //     ) : (
      //       <Tag color={"purple"}>
      //         <span>{text?.text}</span>
      //         <br />
      //         <span>{text?.rate} étoiles</span>
      //       </Tag>
      //     )
      // },
      {
        title: "Status",
        dataIndex: "status",
        render: (text) => (
          <Tag
            color={
              text === 0
                ? "orange"
                : text === 1
                ? "green"
                : text === 2
                ? "yellow"
                : text === 3
                ? "purple"
                : text === 4
                ? "volcano"
                : "blue"
            }
          >
            <b>
              {text === 0 && "Waiting"}
              {text === 1 && "Accepted"}
              {text === 2 && "On way"}
              {text === 3 && "Delivered"}
              {text === 4 && "Canceled"}
              {text === 5 && "Reimburse"}
            </b>
          </Tag>
        )
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const { selectedRowKeys, allowed, blocked, overall } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      selections: [
        Table.SELECTION_ALL,
        Table.SELECTION_INVERT,
        Table.SELECTION_NONE,
        {
          key: "odd",
          text: "Select Odd Row",
          onSelect: (changableRowKeys) => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return false;
              }
              return true;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          }
        },
        {
          key: "even",
          text: "Select Even Row",
          onSelect: (changableRowKeys) => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return true;
              }
              return false;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          }
        }
      ]
    };

    const MenuButton = (record) => (
      <Menu>
        {/* <Menu.Item>
          <Order_edit row={record} />
        </Menu.Item> */}

        {/* <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 0)}>
            En attente
          </Link>
        </Menu.Item> */}

        {record.status === 0 && (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, 1)}>
              Accept Order
            </Link>
          </Menu.Item>
        )}

        {record.status === 0 && (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, 4)}>
              Reject Order
            </Link>
          </Menu.Item>
        )}

        {/* <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 2)}>
            En chemin
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 3)}>Livrer</Link>
        </Menu.Item>

       

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 5)}>
            Rembourser
          </Link>
        </Menu.Item> */}

        {/* <Menu.Item>
          <Link onClick={() => this.handleDelete(record._id)}>Supprimer</Link>
        </Menu.Item> */}
      </Menu>
    );

    const AnyReactComponent = ({ long, lat, path }) => (
      <div
        onClick={() => {
          this.setState({ openModal: true });
        }}
      >
        <img src={path} style={{ width: 50, height: 50 }} />
      </div>
    );

    const {
      load,
      data,
      selected,
      start,
      end,
      ride_selected,
      chef,
      chef_selected,
      selected_date
    } = this.state;
    return (
      <>
        <PageHeader
          onBack={() => {
            //  window.history.back()
          }}
          title="Commandes"
          tags={<Tag color="blue">Liste des commandes</Tag>}
          subTitle=""
          extra={[
            this.props.status < 2 && (
              <Button
                style={{
                  marginLeft: 10
                }}
                type={"danger"}
                onClick={() => {}}
              >
                Rechercher des livreurs
              </Button>
            ),
            <RangePicker
              showTime
              onChange={(data) => {
                console.log(data);
                if (data === null) {
                  this.setState({
                    start: null,
                    end: null
                  });
                }
                let d1 = data[0].format("YYYY-MM-DDTHH:mm:ss");
                let d2 = data[1].format("YYYY-MM-DDTHH:mm:ss");

                this.setState({ start: d1, end: d2 });
              }}
            />,
            <CSVLink data={data}>Exporter CSV/Excel</CSVLink>
          ]}
        >
          <Row>
            <Statistic
              title="Total"
              value={
                data?.filter((item) => {
                  if (start === null && end === null) {
                    return item;
                  }
                  return item.createdAt >= start && item.createdAt <= end;
                })?.length
              }
            />
          </Row>
          {/* <Row>
            <div
              id="mapping"
              style={{ height: "35vh", width: "100%", marginTop: 10 }}
            >
              <GoogleMapReact
                bootstrapURLKeys={{ key: google_map_key }}
                defaultCenter={this.props.center}
                defaultZoom={this.props.zoom}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={this.handleGoogleMapApi}
              >
                {ride_selected !== null && (
                  <AnyReactComponent
                    lat={ride_selected?.chef_id?.position?.lat}
                    lng={ride_selected?.chef_id?.position?.lng}
                    path={startIcon}
                  />
                )}
                {ride_selected !== null && (
                  <AnyReactComponent
                    lat={ride_selected?.user_id?.position?.lat}
                    lng={ride_selected?.user_id?.position?.lng}
                    path={dest}
                  />
                )}

                {ride_selected !== null &&
                  ride_selected.driver_data._id !== null && (
                    <AnyReactComponent
                      lat={ride_selected?.current_position?.lat}
                      lng={ride_selected?.current_position?.lng}
                      path={bike}
                    />
                  )}
              </GoogleMapReact>
            </div>
          </Row> */}

          <Row
            style={{
              marginTop: 20
            }}
          >
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table
                  rowSelection={rowSelection}
                  // size="small"
                  scroll={{
                    x: "auto"
                  }}
                  columns={columns}
                  dataSource={data?.filter((item) => {
                    if (start === null && end === null) {
                      return item;
                    }
                    return item.createdAt >= start && item.createdAt <= end;
                  })}
                />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchStoreToProps)(Order);
